import React, { useEffect, useRef, useState } from "react";
import _ from "lodash";
import { getControlField } from "../../../../Services/tooltipService";
import { getCustomerFields } from "../../../../Services/fieldsServices";
import DataTable from "../../../../Components/UiComponents/DataTable";
import { api } from "../../../../Apis/interceptor";
import ToastElement from "../../../../Components/UiComponents/ToastElement";
import Loader from "../../../../Components/UiComponents/Loader";
import HeaderSearchBar from "../../../../Components/UiComponents/HeaderSearch";
import DropdownElement from "../../../../Components/UiComponents/DropdownElement";
import { getOppData, movingStages } from "../../../../Services/opportunityService";
import { useNavigate } from "react-router-dom";
import ButtonElement from "../../../../Components/UiComponents/ButtonElement";
import PlaylistVideos from "../../../../Components/Videos/PlaylistVideos";
import { Dialog } from "primereact/dialog";

const Stages = (props) => {
    const [customerId, setCustomerId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [controlPanelTabs, setControlPanelTabs] = useState({});
    const [controlStageHeaders, setControlStageHeaders] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [searchedLength, setSearchedLength] = useState(0);
    const navigate = useNavigate()
    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 10
    });
    const [totalRecords, setTotalRecords] = useState(0);
    const [filterOppData, setFilterOppData] = useState([]);
    const [oppData, setOppData] = useState([]);
    const [stage, setStage] = useState([]);
    const [showVideo, setShowVideo] = useState(false);

    const toastRef = useRef()

    var enduser = localStorage.getItem("enduser")
    if (enduser) {
        var tmpData = JSON.parse(enduser);
    }

    useEffect(() => {
        const customerData = localStorage.getItem("enduser");
        if (customerData) {
            const customerDataInJSON = JSON.parse(customerData);
            setCustomerId(customerDataInJSON.customer);
        } else {
            navigate("/login")
            localStorage.clear()
        }
    }, []);

    useEffect(() => {
        if (customerId) {
            getCustomer();
            getControlFieldData();
        }
    }, [customerId]);

    useEffect(() => {
        if (customerId && stage.length > 0) {
            getOppList()
        }
    }, [customerId, stage]);

    useEffect(() => {
        if (lazyParams) {
            getOppList();
        }
    }, [lazyParams]);

    const getCustomer = async () => {
        try {
            if (customerId === null) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Missing customer ID'
                });
                return;
            }
            if (customerId !== null) {
                const response = await getCustomerFields(customerId);
                let data = response?.data?.reference_data
                let stage = data.filter(item => item.option_names === 'WinWorkStage')
                setStage(stage[0].option_choice)
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
    }

    const getWinstages = (currStage) => {
        var currStageIndex = _.findIndex(stage, {
            label: currStage,
        });

        return stage.slice(0, currStageIndex + 1);
    };

    const getOppList = async () => {
        try {
            if (customerId === null) {
                return;
            }
            const { first, rows } = lazyParams;

            var response = await api.get("/api/v1/stage_filter", {
                params: {
                    cust_id: customerId,
                    pattern: searchQuery || '',
                    skip: first,
                    limit: rows
                },
            })
            if (response && response.data) {
                var oppData = response.data.opp;
                setFilterOppData(response.data.opp)
                setTotalRecords(response.data.count);
                for (var i = 0; i < response.data.opp.length; i++) {
                    oppData[i].winstages = getWinstages(
                        oppData[i].winwork_stage
                    );
                }
                setOppData(oppData)
            };
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
    }

    const getControlFieldData = async () => {
        try {
            if (customerId === null) {
                toastRef.current.showToast({
                    type: 'error',
                    message: 'Missing customer ID'
                });
                return;
            }
            var clientModuleData = await getControlField(customerId)
            var controlPanelModules = _.find(clientModuleData?.data?.cust[0].modules, { module_name: "Control Panel", status: true });
            var controlPanelTabs = _.find(controlPanelModules.tabs, { tab_name: "Stages", status: true });
            setControlPanelTabs(controlPanelTabs)
            var cntlPannel_Stages = _.find(controlPanelModules.tabs, { tab_name: "Stages" }).tables;
            var cntlPannelStagesHeaders = _.find(cntlPannel_Stages, { table_name: "Stages" }).headers;
            setControlStageHeaders(cntlPannelStagesHeaders)
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
    }

    const textEditor = (rowData) => {
        return <DropdownElement
            value={rowData.rowData.winstages.filter(
                (item) => item.text === rowData.rowData.winwork_display
            )[0]}
            onChange={(e) => rowData.editorCallback(e.value.text)}
            options={(rowData.rowData.winstages != undefined && rowData.rowData.winstages.length > 0) ? rowData.rowData.winstages : []}
            optionLabel="text"
            placeholder="-- Please select --"
            className="w-full"
        />
    };

    const columns = [
        {
            field: "opportunity_seq",
            header: _.find(controlStageHeaders, { header_name: "Project ID" })?.display_name,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable',
            style: { width: '15%' }
        },
        {
            field: "opportunity_name",
            header: _.find(controlStageHeaders, { header_name: "Project" })?.display_name,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable',
            style: { width: '35%' }
        },
        {
            field: "winwork_display",
            header: _.find(controlStageHeaders, { header_name: "Stage" })?.display_name,
            headerClassName: "header-datatable white-space",
            className: 'row-datatable',
            editor: textEditor,
            style: { width: '35%' }
        }
    ]

    const rowEditClick = async (selectedOpp) => {
        try {
            setLoading(true)
            var originalData = selectedOpp.winstages.filter(
                (item) => item.text === selectedOpp.winwork_display
            )[0]
            selectedOpp.winwork_stage = originalData.label
            selectedOpp.winwork_display = originalData
            var oppData = await getOppData(selectedOpp._id)
            if (oppData && oppData.data) {
                var curData = oppData.data;
                var curStage = stage.find(
                    (item) => item.label === curData.winwork_stage
                );
                var curIndex = stage.indexOf(curStage);

                var moveStage = stage.find(
                    (item) => item.label === selectedOpp.winwork_stage
                );
                var moveIndex = stage.indexOf(moveStage);

                var diff = curIndex - moveIndex;
                selectedOpp.fromStage = curData.winwork_stage;
                selectedOpp.updatedBy = tmpData.username;
                selectedOpp.toDisplay = moveStage.text;

                if (diff != 0) {
                    var res = await movingStages(selectedOpp)
                    if (res && res.data) {
                        toastRef.current.showToast({
                            type: 'success',
                            message: "Gateway Undo successful"
                        });
                        getOppList()
                    }
                } else if (diff == 0) {
                    toastRef.current.showToast({
                        type: 'error',
                        message: "Select different stage"
                    });
                }
            }
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        } finally {
            setLoading(false)
        }
    }

    const filteredQuestionsArray = (query) => {
        const lowerCaseQuery = query.toLowerCase();

        if (lowerCaseQuery.length === 0) {
            getOppList();
            setSearchedLength(lowerCaseQuery.length);
        } else {
            if (lowerCaseQuery.length > searchedLength) {
                setSearchedLength(lowerCaseQuery.length);
            } else {
                setSearchedLength(lowerCaseQuery.length);
            }
            const filteredData = filterOppData.filter(item => {
                return Object.values(item).some(value => {
                    if (value != null) {
                        return value.toString().toLowerCase().includes(lowerCaseQuery);
                    }
                });
            });
            setOppData(filteredData);
        }
    }

    const handleSearchChange = (e) => {
        const invalidCharsRegex = /[()*+\\\[\]?]/;
        if (invalidCharsRegex.test(e)) {
            // If invalid characters are found, do nothing
            return;
        }
        setSearchQuery(e);
        setLazyParams({
            ...lazyParams,
            first: 0,
            page: 0
        });
        // filteredQuestionsArray(e.target.value)
    };

    const handleClearFilter = () => {
        setSearchQuery("");
        setLazyParams({
            ...lazyParams,
            first: 0,
            page: 0
        });
        filteredQuestionsArray("");
    };

    const onPage = (event) => {
        setLazyParams({
            ...lazyParams,
            first: event.first,
            rows: event.rows,
            page: event.page,
        });
    };

    const handleButtonClick = () => {
        setShowVideo(true);
    };

    const closeVideo = () => {
        setShowVideo(false);
    };

    return (
        <div>
            <ToastElement ref={toastRef} />
            <Loader loading={loading} />
            <div className="form-group row align-items-center mb-0 mt-0">
                <div className="col pr-0 pl-0">
                    <div className="flex align-items-center justify-space-between">
                        <p className="label-text">
                            {controlPanelTabs?.display_name}
                        </p>
                        <ButtonElement
                            className="upload-button"
                            type="button"
                            icon="pi pi-video"
                            onClick={handleButtonClick}
                        />
                    </div>
                    <p className="group-table-text-section">
                        Please adjust the current stage of each project
                    </p>
                </div>
            </div>
            <div className="group-table-buttons mt-0">
                <div className="delete-button"></div>
                <div className="group-table-search">
                    <HeaderSearchBar
                        value={searchQuery}
                        onChange={(e) => handleSearchChange(e)}
                        onClick={handleClearFilter}
                    />
                </div>
            </div>
            <div className="data-submit">
                <DataTable
                    value={oppData}
                    columns={columns}
                    dataKey="_id"
                    isRowEditorPage={true}
                    rowEditClick={rowEditClick}
                    onPage={onPage}
                    lazyParams={lazyParams}
                    totalRecords={totalRecords}
                    header={true}
                />
            </div>
            <Dialog id="videoModal" visible={showVideo}
                breakpoints={{
                    '1200px': '80vw',    // Larger modal on bigger screens
                    '1024px': '85vw',    // Slightly smaller for medium screens
                    '769': '90vw',     // Responsive on tablets
                    '641px': '95vw',     // Almost full-width on mobile
                }}
                modal className="table-dialog width-32" draggable={false} width="800px" height="500px" onHide={closeVideo}
            >
                <div className="video-overlay">
                    <div className="video-container">
                        <PlaylistVideos playlistId={process.env.REACT_APP_CONTROL_PANEL_PLAYLIST_ID} apiKey={process.env.REACT_APP_GOOGLE_API_KEY} module="control_panel_stages" />
                    </div>
                </div>
            </Dialog>
        </div>
    )
}

export default Stages;